/**
 * search.js — Results-page search field clear control.
 *
 * <search-field> wraps the results-page search form and adds a dedicated clear
 * (✕) button that empties the input — shown only while the field holds text.
 * The button is type="button", so it NEVER interferes with submission: Enter
 * and the submit button always run the native GET search to /search?q=…
 */
class SearchField extends TRYComponent {
  #input;
  #clear;

  connectedCallback() {
    super.connectedCallback();
    this.#input = this.getRequired('.search-header__input');
    this.#clear = this.getRequired('.search-header__clear');

    this.#sync();
    this.#input.addEventListener('input', this.#sync);
    this.#clear.addEventListener('click', this.#onClear);
  }

  disconnectedCallback() {
    this.#input?.removeEventListener('input', this.#sync);
    this.#clear?.removeEventListener('click', this.#onClear);
  }

  #sync = () => {
    this.#clear.hidden = this.#input.value.length === 0;
  };

  #onClear = () => {
    this.#input.value = '';
    this.#sync();
    this.#input.focus();
  };
}

customElements.define('search-field', SearchField);
